import { useQuery } from "@tanstack/react-query";
import { VisitorType } from "@gettactic/api";

export interface VisitorTypesAPI {
  client: {
    visitorTypes: {
      list: () => Promise<{
        ok: boolean;
        result?: { elements: VisitorType[] } | null;
      }>;
      get: (id: string) => Promise<{
        ok: boolean;
        result?: VisitorType | null;
      }>;
    };
  };
}

export const VISITOR_TYPES_QUERY_KEY = "visitorTypes";

export interface UseVisitorTypesOptions {
  /**
   * If provided, only fetch these specific visitor types.
   * If empty array or undefined, fetch all visitor types.
   */
  typeIds?: string[];
  enabled?: boolean;
}

export function useVisitorTypes(
  options: UseVisitorTypesOptions,
  api: VisitorTypesAPI
) {
  const { typeIds, enabled = true } = options;

  return useQuery({
    queryKey: [VISITOR_TYPES_QUERY_KEY, typeIds],
    queryFn: async () => {
      if (!typeIds || typeIds.length === 0) {
        // Fetch all visitor types
        const response = await api.client.visitorTypes.list();
        if (response.ok && response.result?.elements) {
          return response.result.elements;
        }
        return [];
      }

      // Fetch only specified types
      const types: VisitorType[] = [];
      for (const id of typeIds) {
        const response = await api.client.visitorTypes.get(id);
        if (response.ok && response.result) {
          types.push(response.result);
        }
      }
      return types;
    },
    enabled
  });
}
